<template>
  <div class="left-nav">
    <div class="left-nav-header">
      <div class="left-nav-header-box">
        <div class="title">栏目导航</div>
      </div>
    </div>
    <div class="left-nav-menu-box">
      <el-menu
        :default-active="activeKey"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelect"
      >
        <el-submenu
          :index="item.id"
          v-for="(item, i) in menu.filter((item) => item.children && item.children.length > 0)"
          :key="i"
        >
          <template slot="title">
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item v-for="(data, index) in item.children" :key="index" :index="data.id">{{ data.name }}</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftNav",
  components: {},
  computed: {
    menu() {
      return this.$store.state.menuState.menu;
    },
    activeKey() {
      return this.$store.state.menuState.activeKey;
    },
  },
  mounted() {
    let activeKey = window.sessionStorage.getItem("activeKey");
    if (activeKey) {
      this.$store.commit("menuState/setActiveKey", activeKey);
    }
    let currentNav = window.sessionStorage.getItem("currentNav");
    if (currentNav) {
      this.$store.commit("menuState/setCurrentNav", JSON.parse(currentNav));
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      //   console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //   console.log(key, keyPath);
    },
    handleSelect(index, indexPath) {
      let menuArray = [...this.menu];
      for (let i = 0; i < menuArray.length; i++) {
        let selectHref = "";
        if (menuArray[i].children) {
          for (let j = 0; j < menuArray[i].children.length; j++) {
            if (menuArray[i].children[j].id == index) {
              window.sessionStorage.setItem("activeKey", index);
              window.sessionStorage.setItem("currentNav", JSON.stringify(menuArray[i].children[j]));
              this.$store.commit("menuState/setCurrentNav", menuArray[i].children[j]);
              this.$store.commit("menuState/setActiveKey", index);
              selectHref = menuArray[i].href;
              if (this.$route.path != selectHref) {
                this.$router.push(selectHref);
              }
            }
          }
        }

        // if (selectHref === menuArray[i].href) {
        //   menuArray[i].active = true;
        // } else {
        //   if (selectHref !== "/detail" && selectHref !== "/more") {
        //     menuArray[i].active = false;
        //   }
        // }
      }
      //   this.$store.commit("menuState/setMenu", menuArray);
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
